/**
 * @fileoverview
 * @enhanceable
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.UT.PROTO.AccountStatus', null, global);
goog.exportSymbol('proto.UT.PROTO.AccountType', null, global);
goog.exportSymbol('proto.UT.PROTO.AlertCondition', null, global);
goog.exportSymbol('proto.UT.PROTO.AuctionStatus', null, global);
goog.exportSymbol('proto.UT.PROTO.AutoSquareOffState', null, global);
goog.exportSymbol('proto.UT.PROTO.BOCOPriceType', null, global);
goog.exportSymbol('proto.UT.PROTO.BocoOrderStatus', null, global);
goog.exportSymbol('proto.UT.PROTO.BocoStrategyUpdateType', null, global);
goog.exportSymbol('proto.UT.PROTO.BookType', null, global);
goog.exportSymbol('proto.UT.PROTO.BracketCoverOrderState', null, global);
goog.exportSymbol('proto.UT.PROTO.BrokerConnectionStatus', null, global);
goog.exportSymbol('proto.UT.PROTO.ClientCategory', null, global);
goog.exportSymbol('proto.UT.PROTO.ClientType', null, global);
goog.exportSymbol('proto.UT.PROTO.CommandCategory', null, global);
goog.exportSymbol('proto.UT.PROTO.ConfirmationType', null, global);
goog.exportSymbol('proto.UT.PROTO.ConnectivityType', null, global);
goog.exportSymbol('proto.UT.PROTO.ContractType', null, global);
goog.exportSymbol('proto.UT.PROTO.DMS_REQUESTS', null, global);
goog.exportSymbol('proto.UT.PROTO.DMS_RESPONSES', null, global);
goog.exportSymbol('proto.UT.PROTO.EmailSMSType', null, global);
goog.exportSymbol('proto.UT.PROTO.ExchangeId', null, global);
goog.exportSymbol('proto.UT.PROTO.ExchangeSegmentType', null, global);
goog.exportSymbol('proto.UT.PROTO.ExposureSecurityType', null, global);
goog.exportSymbol('proto.UT.PROTO.FILE_TYPE', null, global);
goog.exportSymbol('proto.UT.PROTO.FileTransferStatus', null, global);
goog.exportSymbol('proto.UT.PROTO.FirstFetchMsgType', null, global);
goog.exportSymbol('proto.UT.PROTO.GrossExposureType', null, global);
goog.exportSymbol('proto.UT.PROTO.HistoricalBookType', null, global);
goog.exportSymbol('proto.UT.PROTO.HistoricalObCols', null, global);
goog.exportSymbol('proto.UT.PROTO.HistoricalTbCols', null, global);
goog.exportSymbol('proto.UT.PROTO.HoldingRequestType', null, global);
goog.exportSymbol('proto.UT.PROTO.JsonRequestType', null, global);
goog.exportSymbol('proto.UT.PROTO.JsonResponseType', null, global);
goog.exportSymbol('proto.UT.PROTO.LEG', null, global);
goog.exportSymbol('proto.UT.PROTO.LoginHistoryDataType', null, global);
goog.exportSymbol('proto.UT.PROTO.LoginHistoryResponseType', null, global);
goog.exportSymbol('proto.UT.PROTO.LoginResponseCategory', null, global);
goog.exportSymbol('proto.UT.PROTO.LoginType', null, global);
goog.exportSymbol('proto.UT.PROTO.MarginCalculatorErrorCode', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketSession', null, global);
goog.exportSymbol('proto.UT.PROTO.MessageType', null, global);
goog.exportSymbol('proto.UT.PROTO.OhlcDataResponseCategory', null, global);
goog.exportSymbol('proto.UT.PROTO.OhlcInterval', null, global);
goog.exportSymbol('proto.UT.PROTO.OptionAttribute', null, global);
goog.exportSymbol('proto.UT.PROTO.OptionMode', null, global);
goog.exportSymbol('proto.UT.PROTO.OrderCateGory', null, global);
goog.exportSymbol('proto.UT.PROTO.OrderMode', null, global);
goog.exportSymbol('proto.UT.PROTO.OrderModeAllowed', null, global);
goog.exportSymbol('proto.UT.PROTO.OrderStatus', null, global);
goog.exportSymbol('proto.UT.PROTO.OrderType', null, global);
goog.exportSymbol('proto.UT.PROTO.OrderValidity', null, global);
goog.exportSymbol('proto.UT.PROTO.ParticipantType', null, global);
goog.exportSymbol('proto.UT.PROTO.PcsResposeCategory', null, global);
goog.exportSymbol('proto.UT.PROTO.PlatformTypes', null, global);
goog.exportSymbol('proto.UT.PROTO.PositionSide', null, global);
goog.exportSymbol('proto.UT.PROTO.PositionUpdateType', null, global);
goog.exportSymbol('proto.UT.PROTO.ProductOrderCateGory', null, global);
goog.exportSymbol('proto.UT.PROTO.ProductType', null, global);
goog.exportSymbol('proto.UT.PROTO.ReceiverType', null, global);
goog.exportSymbol('proto.UT.PROTO.RegisterationType', null, global);
goog.exportSymbol('proto.UT.PROTO.Requests', null, global);
goog.exportSymbol('proto.UT.PROTO.ResponseCategory', null, global);
goog.exportSymbol('proto.UT.PROTO.Responses', null, global);
goog.exportSymbol('proto.UT.PROTO.Responses_GENERIC_RESPONSE_ENUM', null, global);
goog.exportSymbol('proto.UT.PROTO.RmsCheckCombinationType', null, global);
goog.exportSymbol('proto.UT.PROTO.SecurityType', null, global);
goog.exportSymbol('proto.UT.PROTO.SecurityTypeForBaseStrategy', null, global);
goog.exportSymbol('proto.UT.PROTO.SelfTradeOrderFlag', null, global);
goog.exportSymbol('proto.UT.PROTO.ServiceReturnValueCodes', null, global);
goog.exportSymbol('proto.UT.PROTO.SnapshotDataResponseCategory', null, global);
goog.exportSymbol('proto.UT.PROTO.Source', null, global);
goog.exportSymbol('proto.UT.PROTO.SourceId', null, global);
goog.exportSymbol('proto.UT.PROTO.SquareOffStatus', null, global);
goog.exportSymbol('proto.UT.PROTO.StaticDataFlag', null, global);
goog.exportSymbol('proto.UT.PROTO.StopLossType', null, global);
goog.exportSymbol('proto.UT.PROTO.StrategyActionType', null, global);
goog.exportSymbol('proto.UT.PROTO.StrategyRequestStatus', null, global);
goog.exportSymbol('proto.UT.PROTO.StrategyStatus', null, global);
goog.exportSymbol('proto.UT.PROTO.TEMPLATE_TYPE', null, global);
goog.exportSymbol('proto.UT.PROTO.TRANSACTION_TYPE', null, global);
goog.exportSymbol('proto.UT.PROTO.TransactionType', null, global);
goog.exportSymbol('proto.UT.PROTO.USER_TYPE', null, global);
goog.exportSymbol('proto.UT.PROTO.UserProductTemplateError', null, global);
goog.exportSymbol('proto.UT.PROTO.WarningType', null, global);
/**
 * @enum {number}
 */
proto.UT.PROTO.Requests = {
  REQUESTS_BEGIN: 0,
  REQUESTS_WEB_MOBILE_LOGIN: 5000,
  REQUESTS_WEB_MOBILE_LOGOUT: 5001,
  REQUESTS_HEART_BEAT: 5002,
  REQUESTS_SINGLE_ORDER: 5003,
  REQUESTS_WEB_FIRST_FETCH: 5004,
  REQUESTS_WEB_REGISTRATION: 5005,
  REQUESTS_WEB_MOBILE_PASSWORD_CHANGE: 5006,
  REQUESTS_WEB_MOBILE_PCS: 5007,
  REQUESTS_BATCH_ORDER: 5008,
  REQUESTS_MARKET_SESSION_ON_LOGIN: 5009,
  REQUESTS_BOCO_ORDER: 5010,
  REQUESTS_AUCTION_ENQUIRY: 5011,
  REQUESTS_MULTI_LEG_ORDER: 5012,
  REQUESTS_CARE_ORDER: 5013,
  REQUESTS_CLIENTCODE_SUBSCRIPTION: 5014,
  REQUESTS_WEB_TO_API_STRATEGY: 5015,
  REQUESTS_JSON_DATA: 5016,
  REQUESTS_LOGIN_HANDLER: 5017,
  REQUEST_MAX: 7000
};

/**
 * @enum {number}
 */
proto.UT.PROTO.Responses = {
  RESPONSES_LOGIN: 0,
  RESPONSES_WEB_QUOTE_FIRST_FETCH: 1,
  RESPONSES_FORCE_LOGOUT: 2,
  RESPONSES_WEB_INDEX_FIRST_FETCH: 3,
  RESPONSES_WEB_OPEN_INTEREST_FIRST_FETCH: 4,
  RESPONSES_MARKET_SESSION_ON_LOGIN: 5,
  RESPONSES_ORDER: 6,
  RESPONSES_API_STRATEGY_TO_WEB: 7,
  RESPONSES_JSON_DATA: 8,
  RESPONSES_GENERIC_RESPONSE: 9,
  RESPONSES_WEB_FIRST_FETCH: 10,
  RESPONSES_AUCTION_ENQUIRY_INFO: 6001,
  RESPONSES_HFT_SERVER_ID: 6002,
  RESPONSE_MAX: 7000
};

/**
 * @enum {number}
 */
proto.UT.PROTO.LoginResponseCategory = {
  LOGINRESPONSECATEGORY_SUCCESS: 0,
  LOGINRESPONSECATEGORY_NOT_CONFIGURED: 1,
  LOGINRESPONSECATEGORY_ALREADY_CONNECTED: 2,
  LOGINRESPONSECATEGORY_HFT_DATA_REPLAYING: 3,
  LOGINRESPONSECATEGORY_HFT_UNIQUE_ID_MISMATCH: 4,
  LOGINRESPONSECTGRY_MAX: 5
};

/**
 * @enum {number}
 */
proto.UT.PROTO.PlatformTypes = {
  PLATFORMTYPES_BEGIN: 0,
  PLATFORMTYPES_EXE_CONSOLE: 1,
  PLATFORMTYPES_WEB_CONSOLE: 2,
  PLATFORMTYPES_MOBILE_CONSOLE: 3,
  PLATFORMTYPES_DMA_CONSOLE: 4,
  PLATFORMTYPES_API_CONSOLE: 5,
  PLATFORMTYPES_SILENT_LOGIN: 7,
  PLATFORMTYPE_MAX: 6
};

/**
 * @enum {number}
 */
proto.UT.PROTO.OrderStatus = {
  ORDERSTATUS_PENDING: 0,
  ORDERSTATUS_CONFIRMED: 1,
  ORDERSTATUS_FILLED: 2,
  ORDERSTATUS_CANCELED: 3,
  ORDERSTATUS_REPLACED: 4,
  ORDERSTATUS_NEW_REJECTED: 5,
  ORDERSTATUS_CANCEL_REJECTED: 6,
  ORDERSTATUS_REPLACE_REJECTED: 7,
  ORDERSTATUS_FROZEN: 8,
  ORDERSTATUS_MARKET_TO_LIMIT: 9,
  ORDERSTATUS_TRIGGERED: 10,
  ORDERSTATUS_PARTIALLY_FILLED: 11,
  ORDERSTATUS_CANCELED_OF_IOC: 12,
  ORDERSTATUS_RMS_REJECT: 13,
  ORDERSTATUS_TRADE_CANCEL: 14,
  ORDERSTATUS_TRADE_CORRECT: 15,
  ORDERSTATUS_TRADE_MODIFY: 16,
  ORDERSTATUS_RELAYED_TRADE: 17,
  ORDERSTATUS_RELAYED_MODIFIED_TRADE: 18,
  ORDERSTATUS_GIVEUP_UPDATE: 19,
  ORDERSTATUS_PENDING_NEW: 20,
  ORDERSTATUS_PENDING_REPLACE: 21,
  ORDERSTATUS_PENDING_CANCEL: 22,
  ORDERSTATUS_FILEREPLAYER_TRADE: 23,
  ORDERSTATUS_FILEREPLAYER_MODIFIED_TRADE: 24,
  ORDERSTATUS_BOD_POSITION: 25,
  ORDERSTATUS_SUSPENDED_CONFIRMED: 26,
  ORDERSTATUS_SUSPENDED_REPLACED: 27,
  ORDERSTATUS_RESTATED: 28,
  ORDERSTATUS_FILLED_WITHOUT_POSITIONS: 29,
  ORDERSTATUS_TRADE_MODIFICATION_PENDING: 30,
  ORDERSTATUS_TRADE_MODIFICATION_REJECTED: 31,
  ORDERSTATUS_AMO_CONFIRMED: 32,
  ORDERSTATUS_AMO_MODIFIED: 33,
  ORDERSTATUS_AMO_CANCELED: 34,
  ORDERSTATUS_AMO_REJECTED: 35,
  ORDERSTATUS_AMO_EXCHANGE_PUSHED: 36,
  ORDERSTATUS_CONVERTED_ORDER_STRATEGY_TO_MANUAL: 37,
  ORDERSTATUS_QUEUED_CONFIRMED: 38,
  ORDERSTATUS_QUEUED_EXECUTED: 39,
  ORDERSTATUS_QUEUED_CANCELED: 40,
  ORDSTATUS_MAX: 41
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ProductType = {
  PRODUCTTYPE_DELIVERY: 0,
  PRODUCTTYPE_INTRADAY: 1,
  PRODUCTTYPE_CARRYFORWARD: 2,
  PRDTYPE_MAX: 3
};

/**
 * @enum {number}
 */
proto.UT.PROTO.OrderCateGory = {
  ORDERCATEGORY_SINGLE: 0,
  ORDERCATEGORY_SPREAD: 1,
  ORDERCATEGORY_PAIRED: 2,
  ORDERCATEGORY_STRADDLE: 3,
  ORDERCATEGORY_MULTILEG: 4,
  ORDERCATEGORY_MASSQUOTE: 5,
  ORDERCATEGORY_TRADE_CAPTURE_REPORT: 6,
  ORDERCATEGORY_AFTER_MARKET_ORDER: 7,
  ORDRCATEGRY_MAX: 8
};

/**
 * @enum {number}
 */
proto.UT.PROTO.OrderMode = {
  ORDERMODE_BUY: 0,
  ORDERMODE_SELL: 1,
  ORDERMODE_SELL_SHORT: 2,
  ORDRMODE_MAX: 3
};

/**
 * @enum {number}
 */
proto.UT.PROTO.OrderModeAllowed = {
  ORDERMODEALLOWED_INVALID: 0,
  ORDERMODEALLOWED_BUY: 1,
  ORDERMODEALLOWED_SELL: 2,
  ORDERMODEALLOWED_BOTH: 3,
  ORDERMODEALLOWED_NONE: 4,
  ORDRMODEALLOWED_MAX: 5
};

/**
 * @enum {number}
 */
proto.UT.PROTO.LEG = {
  LEG_LEG1: 0,
  LEG_LEG2: 1,
  LEG_LEG3: 2,
  LEG_LEG4: 3,
  LG_MAX: 4
};

/**
 * @enum {number}
 */
proto.UT.PROTO.OrderValidity = {
  ORDERVALIDITY_DAY: 0,
  ORDERVALIDITY_IOC: 1,
  ORDERVALIDITY_FOK: 2,
  ORDERVALIDITY_GFS: 3,
  ORDERVALIDITY_GFD: 4,
  ORDERVALIDITY_GTD: 5,
  ORDERVALIDITY_GTC: 6,
  ORDERVALIDITY_GFA: 7,
  ORDERVALIDITY_MOC: 8,
  ORDERVALIDITY_GTS: 9,
  ORDERVALIDITY_CROSSING: 10,
  ORDERVALIDITY_EOS: 11,
  ORDERVALIDITY_COL: 12,
  ORDRVALIDITY_MAX: 13
};

/**
 * @enum {number}
 */
proto.UT.PROTO.OrderType = {
  ORDERTYPE_LIMIT: 0,
  ORDERTYPE_MARKET: 1,
  ORDERTYPE_STOP_LIMIT: 2,
  ORDERTYPE_STOP: 3,
  ORDERTYPE_BESTPRICE: 4,
  ORDERTYPE_ASK1: 5,
  ORDERTYPE_BID1: 6,
  ORDERTYPE_ASK1P1: 7,
  ORDERTYPE_ASK1P2: 8,
  ORDERTYPE_ASK1P3: 9,
  ORDERTYPE_BID1P1: 10,
  ORDERTYPE_BID1P2: 11,
  ORDERTYPE_BID1P3: 12,
  ORDERTYPE_MARKET_TO_LIMIT: 13,
  ORDERTYPE_2L: 14,
  ORDERTYPE_3L: 15,
  ORDERTYPE_4L: 16,
  ORDERTYPE_SPREAD: 17,
  ORDRTYPE_MAX: 18
};

/**
 * @enum {number}
 */
proto.UT.PROTO.TransactionType = {
  TRANSACTIONTYPE_NEW: 0,
  TRANSACTIONTYPE_MODIFY: 1,
  TRANSACTIONTYPE_CANCEL: 2,
  TRANSACTIONTYPE_WAIT: 3,
  TRANSACTIONTYPE_DELETE: 4,
  TRNSCTNTYPE_MAX: 5
};

/**
 * @enum {number}
 */
proto.UT.PROTO.AccountType = {
  ACCOUNTTYPE_CLIENT: 0,
  ACCOUNTTYPE_PRO: 1,
  ACCOUNTTYPE_SPLCLIENT: 2,
  ACCOUNTTYPE_INST: 3,
  ACCNTTYPE_MAX: 4
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ParticipantType = {
  PARTICIPANTTYPE_MEMBER_CODE: 0,
  PARTICIPANTTYPE_CP_CODE: 1,
  PARTICIPANTTYPE_INST: 2,
  PARTCPANTTYPE_MAX: 4
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ExchangeSegmentType = {
  EXCHANGESEGMENTTYPE_CM: 0,
  EXCHANGESEGMENTTYPE_FO: 1,
  EXCHANGESEGMENTTYPE_ALL: 2,
  EXCHSGMNTTYPE_MAX: 3
};

/**
 * @enum {number}
 */
proto.UT.PROTO.SecurityType = {
  SECURITYTYPE_COMMON_STOCK: 0,
  SECURITYTYPE_FUTURE: 1,
  SECURITYTYPE_OPTION: 2,
  SECURITYTYPE_SPREAD: 3,
  SECURITYTYPE_AUCTION: 4,
  SECTYPE_MAX: 5
};

/**
 * @enum {number}
 */
proto.UT.PROTO.SecurityTypeForBaseStrategy = {
  SECUIRTYTYPEFORBASESTRATEGY_MIN: 0,
  SECURITYTYPEFORBASESTRATEGY_COMMON_STOCK: 1,
  SECURITYTYPEFORBASESTRATEGY_FUTUREI: 2,
  SECURITYTYPEFORBASESTRATEGY_OPTION: 4,
  SECURITYTYPEFORBASESTRATEGY_SPREAD: 8,
  SECURITYTYPEFORBASESTRTGY_MAX: 15
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ExchangeId = {
  EXCHID_MIN: 0,
  EXCHANGEID_BSECM: 1,
  EXCHANGEID_BSEFO: 2,
  EXCHANGEID_NSECM: 3,
  EXCHANGEID_NSEFO: 4,
  EXCHANGEID_ESMNSE: 5,
  EXCHANGEID_NSECDS: 6,
  EXCHANGEID_BSECDS: 7,
  EXCHANGEID_SGX: 8,
  EXCHANGEID_CFH: 9,
  EXCHANGEID_MAREX: 10,
  EXCHANGEID_MCX: 11,
  EXCHANGEID_DGCX: 12,
  EXCHANGEID_DGCXCD: 13,
  EXCHANGEID_LME: 14,
  EXCHANGEID_CME: 15,
  EXCHANGEID_CFFEX: 16,
  EXCHANGEID_CZCE: 17,
  EXCHANGEID_DCE: 18,
  EXCHANGEID_SHFE: 19,
  EXCHANGEID_SGXCUR: 20,
  EXCHANGEID_SMART: 21,
  EXCHANGEID_ALPHA: 22,
  EXCHANGEID_AMEX: 23,
  EXCHANGEID_ARCA: 24,
  EXCHANGEID_ASX: 25,
  EXCHANGEID_BATS: 26,
  EXCHANGEID_BEX: 27,
  EXCHANGEID_BTRADE: 28,
  EXCHANGEID_BYX: 29,
  EXCHANGEID_CHX: 30,
  EXCHANGEID_DRCTEDGE: 31,
  EXCHANGEID_EBS: 32,
  EXCHANGEID_EDGEA: 33,
  EXCHANGEID_FWB: 34,
  EXCHANGEID_FWB2: 35,
  EXCHANGEID_IEX: 36,
  EXCHANGEID_INET: 37,
  EXCHANGEID_ISLAND: 38,
  EXCHANGEID_LAVA: 39,
  EXCHANGEID_LSE: 40,
  EXCHANGEID_MEXI: 41,
  EXCHANGEID_NASDAQ: 42,
  EXCHANGEID_NYSE: 43,
  EXCHANGEID_NYMEX: 44,
  EXCHANGEID_OMEGA: 45,
  EXCHANGEID_PINK: 46,
  EXCHANGEID_PSX: 47,
  EXCHANGEID_PURE: 48,
  EXCHANGEID_SBF: 49,
  EXCHANGEID_SEHK: 50,
  EXCHANGEID_SELECT: 51,
  EXCHANGEID_SWB: 52,
  EXCHANGEID_SWB2: 53,
  EXCHANGEID_TSE: 54,
  EXCHANGEID_VWAP: 55,
  EXCHANGEID_ONE: 56,
  EXCHANGEID_ECBOT: 57,
  EXCHANGEID_IDEALPRO: 58,
  EXCHANGEID_NASDAQOM: 59,
  EXCHANGEID_GLOBEX: 60,
  EXCHANGEID_ISE: 61,
  EXCHANGEID_EXOTIC: 62,
  EXCHANGEID_MSEICM: 63,
  EXCHANGEID_MOEXFO: 64,
  EXCHANGEID_MOEX: 65,
  EXCHANGEID_IFLL: 66,
  EXCHANGEID_CBT: 67,
  EXCHANGEID_FXALL: 68,
  EXCHANGEID_PLUS: 69,
  EXCHANGEID_NCDEX: 70,
  EXCHANGEID_COMEX: 71,
  EXCHANGEID_BSEINX: 72,
  EXCHANGEID_MSEFO: 73,
  EXCHANGEID_MSECD: 74,
  EXCHANGEID_BIST: 75,
  EXCHANGEID_PXM: 76,
  EXCHANGEID_NYBOT: 77,
  EXCHANGEID_NYSELIFFE: 78,
  EXCHANGEID_NSEIFSC: 79,
  EXCHANGEID_NSECOM: 80,
  EXCHANGEID_BSECOM: 81,
  EXCHANGEID_ICEX: 82,
  EXCHANGEID_MFX: 83,
  EXCHID_MAX: 84
};

/**
 * @enum {number}
 */
proto.UT.PROTO.AlertCondition = {
  ENTRY: 0,
  EXIT: 1,
  REPAIR: 2,
  BID: 3,
  HEDGE: 4,
  LOAD: 5,
  UNLOAD: 6,
  MAX: 7
};

/**
 * @enum {number}
 */
proto.UT.PROTO.DMS_REQUESTS = {
  DMS_REQUEST_LOGIN: 0,
  DMS_USER_HEARTBEAT: 1,
  DMS_REQUEST_LOGOUT: 2,
  DMS_SUBSCRIPTION_REQUEST_FOR_DASHBOARD: 3,
  DMS_REQUEST_OFFLINE_DATA: 4,
  DMS_BEGIN_ONLINE_DATA: 22000
};

/**
 * @enum {number}
 */
proto.UT.PROTO.DMS_RESPONSES = {
  DMS_RESPONSE_LOGIN: 0,
  DMS_RESPONSE_SNAPSHOT_UPDATE: 1,
  DMS_RESPONSE_NOTIFICATIONS: 2,
  DMS_RESPONSE_FORCE_LOGOUT: 3,
  DMS_RESPONSE_DEALER_SNAPSHOT_FOR_WEB: 4,
  DMS_RESPONSE_SQOFF_STATE: 5,
  DMS_RESPONSE_GENERIC_MESSAGE_RECEIVED: 6,
  DMS_RESPONSE_DASHBOARD_DATA: 7,
  DMS_RESPONSE_CONNECTION: 8,
  DMS_RESPONSE_OFFLINE_DATA_COMPLETED: 9,
  DMS_RESPONSE_MAX: 10
};

/**
 * @enum {number}
 */
proto.UT.PROTO.USER_TYPE = {
  USER_TYPE_CLIENT: 0,
  USER_TYPE_ADMIN: 1,
  USER_TYPE_DEALER: 2,
  USER_TYPE_BRANCH: 3,
  USER_TYPE_GROUP: 4,
  USER_TYPE_CALL_AND_TRADE_DEALER_B2C: 5,
  USER_TYPE_OFFLINE_DEALER: 6,
  USR_TYP_MAX: 7
};

/**
 * @enum {number}
 */
proto.UT.PROTO.OptionMode = {
  OPTIONMODE_PUT: 0,
  OPTIONMODE_CALL: 1,
  OPTNMODE_MAX: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.StaticDataFlag = {
  STATICDATAFLAG_USERSTATUS: 0,
  STATICDATAFLAG_MARKETSEGUCC: 1,
  STATICDATAFLAG_BASKETNAMETYPE: 2,
  STATICDATAFLAG_PRODUCTS: 3,
  STATICDATAFLAG_RISKTEMPLATES: 4,
  STATICDATAFLAG_CLIENTWISEPRODUCTS: 5,
  STATICDATAFLAG_CLIENTCODESACCOUNTDETAILS: 6,
  STATICDATAFLAG_PASSWORDPOLICYDETAILS: 7,
  STATICDATAFLAG_CONFIG_PARAMS: 8,
  STATICDATAFLAG_HOLDING_PRODUCTS: 9,
  STATICDATAFLAG_PERMISSIONTEMPLATES: 10,
  STATICDATAFLAG_AFTERMARKETORDERSETTINGS: 11,
  STATICDATAFLAG_STRATEGYLIMITS: 12,
  STATICDATAFLAG_LINKS: 13,
  STATICDATAFLAG_RMSCHECKDETAILS: 14,
  STATICDATAFLAG_DEALERSMAPPEDTOCLIENT: 15,
  STATICDATAFLAG_CLIENT_SENDER_COMP_ID_MAPPINGS: 16,
  STATICDATAFLAG_BOCO_PRODUCT_SETTING: 17,
  STATICDATAFLAG_ALL: 18
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ServiceReturnValueCodes = {
  SERVICERETURNVALUECODE_DEFAULT: 0,
  SERVICERETURNVALUECODE_SUCCESSFUL: 1,
  SERVICERETURNVALUECODE_UNSUCCESSFUL: 2,
  SERVICERETURNVALUECODE_EMAIL_ALREADY_EXIST: 3,
  SERVICERETURNVALUECODE_ID_ALREADY_EXIST: 4,
  SERVICERETURNVALUECODE_FAILED_PRODUCT_SETTING: 5,
  SERVICERETURNVALUECODE_FAILED_SOURCE_MAPPING: 6,
  SERVICERETURNVALUECODE_FAILED_PRODUCT_SYMBOL_SETTING: 7,
  SERVICERETURNVALUECODE_FAILED_PRODUCT_SYMBOL_BASKET_SETTING: 8,
  SERVICERETURNVALUECODE_BASKET_RISK_SETTINGS_MAPPED: 9,
  SERVICERETURNVALUECODE_BASKET_RULE_EXCEPTION_MAPPED: 10,
  SERVICERETURNVALUECODE_CLIENT_NOT_EXIST: 11,
  SERVICERETURNVALUECODE_PRODUCT_ALREADY_EXIST: 12,
  SERVICERETURNVALUECODE_TEMPLATE_MAPPED_TO_USER: 13,
  SERVICERETURNVALUECODE_OUTSTANDING_ORDER_EXIST: 14,
  SERVICERETURNVALUECODE_UCC_INHERITED: 15,
  SERVICERETURNVALUECODE_INVALID_TRANSACTION_TYPE: 16,
  SERVICERETURNVALUECODE_NO_SUCH_FAMILY: 17,
  SERVICERETURNVALUECODE_INVALID_CLIENT_GENERAL_TEMPLATE: 18,
  SERVICERETURNVALUECODE_INVALID_PRODUCT_TEMPLATE: 19,
  SERVICERETURNVALUECODE_INCOMPLETE_EXCHANGE_SETTING: 20,
  SERVICERETURNVALUECODE_INVALID_EXCHANGE: 21,
  SERVICERETURNVALUECODE_INVALID_UCC: 22,
  SERVICERETURNVALUECODE_INVALID_ACCOUNTTYPE: 23,
  SERVICERETURNVALUECODE_INVALID_PARTICIPANTTYPE: 24,
  SERVICERETURNVALUECODE_INVALID_PARTICIPANTCODE: 25,
  SERVICERETURNVALUECODE_INVALID_EMAIL: 26,
  SERVICERETURNVALUECODE_INVALID_ID: 27,
  SERVICERETURNVALUECODE_HOLDING_ALREADY_EXIST: 28,
  SERVICERETURNVALUECODE_DUPLICATE_TRANSACTION: 29,
  SERVICERETURNVALUECODE_INVALID_PAN: 30,
  SERVICERETURNVALUECODE_DELIVERY_PRODUCT_ALREADY_EXISTS: 31,
  SERVICERETURNVALUECODE_PENDING_HOLDING_EXISTS: 32,
  SERVICERETURNVALUE_MAX: 33
};

/**
 * @enum {number}
 */
proto.UT.PROTO.AccountStatus = {
  ACCOUNTSTATUS_ACTIVE: 0,
  ACCOUNTSTATUS_INACTIVE: 1,
  ACCOUNTSTATUS_SUSPENDED: 2,
  ACCOUNTSTATUS_DELETED: 3,
  ACCOUNTSTATUS_FROZEN: 4,
  ACCOUNTSTATUS_INVALID: 5
};

/**
 * @enum {number}
 */
proto.UT.PROTO.OptionAttribute = {
  OPTIONATTRIBUTE_AMERICAN: 0,
  OPTIONATTRIBUTE_EUROPEAN: 1,
  OPTIONATTRBTE_MAX: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.BookType = {
  BKTYPE_MIN: 0,
  BOOKTYPE_REGULAR_LOT: 1,
  BOOKTYPE_SPECIAL_TERMS: 2,
  BOOKTYPE_STOP_LOSS: 3,
  BOOKTYPE_NEGOTIATED: 4,
  BOOKTYPE_ODD_LOT: 5,
  BOOKTYPE_RETDEBT: 6,
  BOOKTYPE_AUCTION: 7,
  BOOKTYPE_CALL_AUCTION_1: 11,
  BOOKTYPE_CALL_AUCTION_2: 12,
  BKTYPE_MAX: 13
};

/**
 * @enum {number}
 */
proto.UT.PROTO.SquareOffStatus = {
  SQUAREOFF_ONLY: 0,
  SQUAREOFF_NO: 1,
  SQUAREOFF_NONE: 2,
  SQUAREOFF_MAX: 3
};

/**
 * @enum {number}
 */
proto.UT.PROTO.Source = {
  SOURCE_SETTLED: 0,
  SOURCE_UNSETTLED: 1,
  SRC_MAX: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.TRANSACTION_TYPE = {
  TRANSACTION_TYPE_INVALID: 0,
  TRANSACTION_TYPE_NEW: 1,
  TRANSACTION_TYPE_MODIFY: 2,
  TRANSACTION_TYPE_DELETE: 3,
  TRANSACTION_MAX: 4
};

/**
 * @enum {number}
 */
proto.UT.PROTO.UserProductTemplateError = {
  USERPRODUCTTEMPLATE_NO_ERROR: 0,
  USERPRODUCTTEMPLATE_TEMPLATE_DONOT_EXISTS: 1,
  USERPRODUCTTEMPLATE_TEMPLATE_ALREADY_EXISTS: 2,
  USERPRODUCTTEMPLATE_TEMPLATE_MODIFIED_BY_OTHER_USER: 3,
  USERPRODUCTTEMPLATE_DB_ERROR: 4,
  USERPRODUCTTEMPLATE_UNKNOWN_ERROR: 5
};

/**
 * @enum {number}
 */
proto.UT.PROTO.TEMPLATE_TYPE = {
  TEMPLATE_TYPE_GENERIC_RISK: 0,
  TEMPLATE_TYPE_PRODUCT_RISK: 1,
  TEMPLATE_MAX: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.CommandCategory = {
  COMMANDCATEGORY_GENERIC_RISK_TEMPLATE: 0,
  COMMANDCATEGORY_PRODUCT_RISK_TEMPLATE: 1,
  COMMANDCATEGORY_USER_MAPPING_DETAILS: 2,
  COMMANDCATEGORY_PRODUCT: 3,
  COMMANDCATEGORY_SYMBOL_BASKET: 4,
  COMMANDCATEGORY_GLOBAL_SYMBOL_RMS_SETTING: 5,
  COMMANDCATEGORY_GLOBAL_UNDERLYING_SETTING: 6,
  COMMANDCATEGORY_FILE_LOADER_UPDATE: 7,
  COMMANDCATEGORY_CLIENT_DEPOSIT: 8,
  COMMANDCATEGORY_RMS_DEPENDENT_DATA_FIRST_FETCH: 9,
  COMMANDCATEGORY_CLIENT_CATEGORY_BAN: 10,
  COMMANDCATEGORY_HIERARCHY_UPDATE: 11,
  COMMANDCATEGORY_UPDATE_AUTO_SQOFF: 12,
  COMMANDCATEGORY_PRE_SQOFF_MANUAL_START: 13,
  COMMANDCATEGORY_AUTOSQOFF_MANUAL_START: 14,
  COMMANDCATEGORY_RESUME_NORMAL_TRADING: 15,
  COMMANDCATEGORY_CLIENT_EXCLUSION: 16,
  COMMANDCATEGORY_HOLDING_UPDATE: 17,
  COMMANDCATEGORY_HOLDING_FILE_UPLOADER: 18,
  COMMANDCATEGORY_CONVERT_PRODUCT: 19,
  COMMANDCATEGORY_MARKET_SESSION: 20,
  COMMANDCATEGORY_CHARTING_DATA: 21,
  COMMANDCATEGORY_SUBSCRIPTION_REQUEST_FOR_DASHBOARD: 22,
  COMMANDCATEGORY_CLIENT_CONNECTION: 23,
  COMMANDCATEGORY_ASM_GSM_BAN: 24,
  COMMANDCATEGORY_PHYSICAL_DELIVERY_BAN: 25,
  COMMANDCATEGORY_RMS_MARGIN_SUMMARY_FIRST_FETCH: 26,
  COMMANDCATEGORY_PROTO_MAX: 27
};

/**
 * @enum {number}
 */
proto.UT.PROTO.FILE_TYPE = {
  FILE_TYPE_POSITION: 0,
  FILE_TYPE_SYMBOL_VAR: 1,
  FILE_TYPE_SYMBOL_ELM: 2,
  FILE_TYPE_SYMBOL_EXPOSURE: 3,
  FILE_TYPE_SYMBOL_EXPOSURE_OTM: 4,
  FILE_MAX: 5
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ResponseCategory = {
  RESPONSECATEGORY_CLIENT_MARGIN_SUMMARY: 0,
  RESPONSECATEGORY_RMS_DMS_MESSAGES: 1,
  RESPONSECATEGORY_PRE_SQOFF_STATE: 2,
  RESPONSECATEGORY_HOLDINGS_UPDATE: 3,
  RESPONSECATEGORY_CLIENT_ALERT_INFO: 4,
  RESPONSECATEGORY_PRODUCT_CONVERSION: 5,
  RESPONSECATEGORY_ENTITY_STATE_MESSAGE: 6,
  RESPONSECATEGORY_DASHBOARD_DATA: 7,
  RESPONSECATEGORY_MTM_DASHBOARD_DATA: 8,
  RESPONSECATEGORY_BRACKET_COVER_ORDER: 9,
  RESPONSECATEGORY_LTP_UPDATE: 10,
  RESPONSECATEGORY_DMS_REGISTRATION: 11,
  RESPONSECATEGORY_SALESTRADER_TO_DEALER: 12,
  RESPONSECATEGORY_DEALER_TO_SALESTRADER: 13,
  RESPONSECATEGORY_CAREORDER_TO_DMS: 14,
  RESPONSECATEGORY_RMS_DMS_MESSAGES_OFFLINE: 15,
  RESPONSECATEGORY_DMS_DISCONNECTED: 16,
  RESPONSECATEGORY_OFFLINE_BRACKET_COVER_ORDER: 17,
  RESPONSECATEGORY_OFFLINE_BOCO_COMPLETED: 18,
  RESPONSECATEGORY_MARKET_SESSION: 19,
  RESPONSECATEGORY_TRADEWISE_TRACKER_DATA: 20,
  RESPONSE_CATEGORY_FIX_CONNECTIVITY_STATUS: 21,
  RESPONSECATEGORY_MAX_: 22
};

/**
 * @enum {number}
 */
proto.UT.PROTO.SelfTradeOrderFlag = {
  SELFTRADEORDERFLAG_CANCEL_ACTIVE: 0,
  SELFTRADEORDERFLAG_CANCEL_PASSIVE: 1,
  SELFTRDEORDERFLAG_MAX: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ContractType = {
  CONTRACTTYPE_NORMAL: 0,
  CONTRACTTYPE_SPREAD: 1,
  CONTRACTTYPE_PAIRED: 2,
  CONTRACTTYPE_STRADDLE: 3,
  CNTRCTTYPE_MAX: 4
};

/**
 * @enum {number}
 */
proto.UT.PROTO.SourceId = {
  SRCID_BEGIN: 0,
  SOURCEID_DEFAULT: 1,
  SOURCEID_MAREX: 2,
  SOURCEID_TT: 3,
  SOURCEID_CTP: 4,
  SOURCEID_IB: 5,
  SOURCEID_OT: 6,
  SRCID_MAX: 7
};

/**
 * @enum {number}
 */
proto.UT.PROTO.HistoricalBookType = {
  ORDER_BOOK: 0,
  TRADE_BOOK: 1,
  REJECTED_ORDER_BOOK: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.HistoricalObCols = {
  HOB_SEQUENCE_NUMBER: 0,
  HOB_CLIENT_ORDER_ID: 1,
  HOB_SYMBOL: 2,
  HOB_ORDER_STATUS: 3,
  HOB_EXCHANGE_ORDER_ID: 4,
  HOB_EXCHANGE_MODIFY_TIME: 5,
  HOB_STRATEGY_ID: 6,
  HOB_SOURCE: 7,
  HOB_EXCHANGE: 8,
  HOB_SCRIP_NAME: 9,
  HOB_INSTRUMENT_TYPE: 10,
  HOB_STRIKE_PRICE: 11,
  HOB_OPTION_MODE: 12,
  HOB_EXPIRY: 13,
  HOB_GROUP_NAME: 14,
  HOB_DEALER_ID: 15,
  HOB_LIMIT_PRICE: 16,
  HOB_ORDER_MODE: 17,
  HOB_ORDER_QUANTITY: 18,
  HOB_ORDER_PRICE: 19,
  HOB_FILLED_QUANTITY: 20,
  HOB_ORIGINAL_CLIENT_ORDER_ID: 21,
  HOB_TRADER_ID: 22,
  HOB_ERROR_CODE: 23,
  HOB_ORDER_CATEGORY: 24,
  HOB_TRADE_ID: 25,
  HOB_ORDER_VALIDITY: 26,
  HOB_CONFIRMATION_TYPE: 27,
  HOB_FIX_CLIENT_ORDER_ID: 28,
  HOB_STOP_PRICE: 29,
  HOB_PRODUCT_TYPE: 30,
  HOB_PLATFORM_TYPE: 31,
  HOB_PRIMARY_CLIENT_CODE: 32,
  HOB_CLIENT_CODE: 33,
  HOB_ACCOUNT_TYPE: 34,
  HOB_LOCATION_ID: 35,
  HOB_UPDATED_BY: 36,
  HOB_EOD_DATE: 37,
  HOB_COL_MAX: 38
};

/**
 * @enum {number}
 */
proto.UT.PROTO.HistoricalTbCols = {
  HTB_DEALER_ID: 0,
  HTB_CLIENT_ORDER_ID: 1,
  HTB_FIX_CLIENT_ORDER_ID: 2,
  HTB_ORDER_MODE: 3,
  HTB_ORDER_CATEGORY: 4,
  HTB_SOURCE: 5,
  HTB_EXCHANGE: 6,
  HTB_SCRIP_NAME: 7,
  HTB_SECURITY_TYPE: 8,
  HTB_EXPIRY: 9,
  HTB_OPTION_MODE: 10,
  HTB_STRIKE_PRICE: 11,
  HTB_STRATEGY_ID: 12,
  HTB_FILLED_QUANTITY: 13,
  HTB_FILLED_PRICE: 14,
  HTB_ORDER_STATUS: 15,
  HTB_EXCHANGE_ORDER_ID: 16,
  HTB_TRADER_ID: 17,
  HTB_PRIMARY_CLIENT_CODE: 18,
  HTB_EXCHANGE_CLIENT_CODE: 19,
  HTB_PART_CODE: 20,
  HTB_EXCHANGE_MODIFY_TIME: 21,
  HTB_GIVE_UP_STATUS: 22,
  HTB_GIVE_UP_TIME: 23,
  HTB_SEQUENCE_NUMBER: 24,
  HTB_ORDER_VALIDITY: 25,
  HTB_GTD_DATE: 26,
  HTB_PRODUCT_TYPE: 27,
  HTB_PLATFORM_TYPE: 28,
  HTB_EOD_DATE: 29,
  HTB_COL_MAX: 30
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ClientCategory = {
  CLIENTCATEGORY_INVALID: 0,
  CLIENTCATEGORY_CLIENT: 1,
  CLIENTCATEGORY_OWN: 2,
  CLIENTCATEGORY_FII: 3,
  CLIENTCATEGORY_DII: 4,
  CLIENTCATEGORY_ALL: 5
};

/**
 * @enum {number}
 */
proto.UT.PROTO.PositionUpdateType = {
  POSITIONUPDATETYPE_CLIENT: 0,
  POSITIONUPDATETYPE_DEALER: 1,
  POSITIONTYPE_MAX: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WarningType = {
  WARNINGTYPE_APPLICATION: 0,
  WARNINGTYPE_EMAIL: 1,
  WARNINGTYPE_SMS: 2,
  WARNTYPE_MAX: 3
};

/**
 * @enum {number}
 */
proto.UT.PROTO.AutoSquareOffState = {
  AUTOSQUAREOFFSTATE_NORMAL_TRADING: 0,
  AUTOSQUAREOFFSTATE_START_PRE: 1,
  AUTOSQUAREOFFSTATE_PRE_RUNNING: 2,
  AUTOSQUAREOFFSTATE_PRE_COMPLETED: 3,
  AUTOSQUAREOFFSTATE_START_AUTO: 4,
  AUTOSQUAREOFFSTATE_AUTO_RUNNING: 5,
  AUTOSQUAREOFFSTATE_AUTO_COMPLETED: 6
};

/**
 * @enum {number}
 */
proto.UT.PROTO.PositionSide = {
  POSITIONSIDE_INVALID: 0,
  POSITIONSIDE_LONG: 1,
  POSITIONSIDE_SHORT: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.MessageType = {
  MESSAGETYPE_INVALID: 0,
  MESSAGETYPE_PRODUCT_CONVERSION: 1,
  MESSAGETYPE_ALERT: 2,
  MESSAGETYPE_BROADCAST_MESSAGES: 3,
  MESSAGETYPE_ENTITY_STATE_MESSAGE: 4,
  MESSAGETYPE_BOCO: 5,
  MESSAGETYPE_MAX: 6
};

/**
 * @enum {number}
 */
proto.UT.PROTO.PcsResposeCategory = {
  PCSRESPOSECATEGORY_INVALID: 0,
  PCSRESPOSECATEGORY_SUCCESSFUL: 1,
  PCSRESPOSECATEGORY_REJECTED: 2,
  PCSRESPOSECATEGORY_MAX: 3
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ReceiverType = {
  RECEIVERTYPE_INVALID: 0,
  RECEIVERTYPE_INDIVIDUAL: 1,
  RECEIVERTYPE_MAPPED_DEALERS: 2,
  RECEIVERTYPE_UP_HIERARCHY: 3,
  RECEIVERTYPE_DOWN_HIERARCHY: 4,
  RECEIVERTYPE_MAX: 5
};

/**
 * @enum {number}
 */
proto.UT.PROTO.FirstFetchMsgType = {
  FIRSTFETCH_QUOTE: 0,
  FIRSTFETCH_INDEX: 1,
  FIRSTFETCH_OPEN_INTEREST: 2,
  FIRSTFETCH_MAX: 3
};

/**
 * @enum {number}
 */
proto.UT.PROTO.MarketSession = {
  MARKETSESSION_PREOPEN: 0,
  MARKETSESSION_OPEN: 1,
  MARKETSESSION_CLOSED: 2,
  MARKETSESSION_PREOPEN_CLOSED: 3,
  MARKETSESSION_POST_CLOSED: 4,
  MARKETSESSION_POST_OPEN: 5,
  MARKETSESSION_HALTED: 6,
  MARKETSESSION_MAX: 7
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ConnectivityType = {
  CONNECTIVITYTYPE_RMS: 0,
  CONNECTIVITYTYPE_BSECM: 1,
  CONNECTIVITYTYPE_NSECM: 2,
  CONNECTIVITYTYPE_NSEFO: 3,
  CONNECTIVITYTYPE_TBTCM: 4,
  CONNECTIVITYTYPE_TBTFO: 5,
  CONNECTIVITYTYPE_BSE_SNAPSHOT_FEED: 6,
  CONNECTIVITYTYPE_NSECM_SNAPSHOT_FEED: 7,
  CONNECTIVITYTYPE_NSEFO_SNAPSHOT_FEED: 8,
  CONNECTIVITYTYPE_NSECDS: 9,
  CONNECTIVITYTYPE_TBTCDS: 10,
  CONNECTIVITYTYPE_BSECDS: 11,
  CONNECTIVITYTYPE_SGX: 12,
  CONNECTIVITYTYPE_CFH: 13,
  CONNECTIVITYTYPE_BSEFO: 14,
  CONNECTIVITYTYPE_CTP: 15,
  CONNECTIVITYTYPE_CTP_CFFEX: 16,
  CONNECTIVITYTYPE_CTP_DCE: 17,
  CONNECTIVITYTYPE_CTP_CZCE: 18,
  CONNECTIVITYTYPE_CTP_SHFE: 19,
  CONNECTIVITYTYPE_DGCX: 20,
  CONNECTIVITYTYPE_MCX: 21,
  CONNECTIVITYTYPE_IB: 22,
  CONNECTIVITYTYPE_EXOTIC: 23,
  CONNECTIVITYTYPE_MSECM: 24,
  CONNECTIVITYTYPE_MOEXFO: 25,
  CONNECTIVITYTYPE_MOEX: 26,
  CONNECTIVITYTYPE_ESM: 27,
  CONNECTIVITYTYPE_SGX_MCL: 28,
  CONNECTIVITYTYPE_OT: 29,
  CONNECTIVITYTYPE_OT_CME: 30,
  CONNECTIVITYTYPE_OT_LME: 31,
  CONNECTIVITYTYPE_OT_IFLL: 32,
  CONNECTIVITYTYPE_OT_CBT: 33,
  CONNECTIVITYTYPE_OT_NYMEX: 34,
  CONNECTIVITYTYPE_TT_SGX: 35,
  CONNECTIVITYTYPE_TT_CME: 36,
  CONNECTIVITYTYPE_TT_LME: 37,
  CONNECTIVITYTYPE_TT_ICE: 38,
  CONNECTIVITYTYPE_TT_CBT: 39,
  CONNECTIVITYTYPE_TT_NYMEX: 40,
  CONNECTIVITYTYPE_FXALL: 41,
  CONNECTIVITYTYPE_PLUS: 42,
  CONNECTIVITYTYPE_NCDEX: 43,
  CONNECTIVITYTYPE_OT_COMEX: 44,
  CONNECTIVITYTYPE_BSEINX: 45,
  CONNECTIVITYTYPE_MSEFO: 46,
  CONNECTIVITYTYPE_MSECD: 47,
  CONNECTIVITYTYPE_TT_NYSE: 48,
  CONNECTIVITYTYPE_TT_NASDAQ: 49,
  CONNECTIVITYTYPE_BIST: 50,
  CONNECTIVITYTYPE_PXM: 51,
  CONNECTIVITYTYPE_DMS: 52,
  CONNECTIVITYTYPE_NSEIFSC: 53,
  CONNECTIVITYTYPE_TBTIFSC: 54,
  CONNECTIVITYTYPE_NSECOM: 55,
  CONNECTIVITYTYPE_BSECOM: 56,
  CONNECTIVITYTYPE_HFT_DMS: 57,
  CONNECTIVITYTYPE_ICEX: 58,
  CONNECTIVITYTYPE_MFX: 59,
  CONNECTIVITYTYPE_MAX: 60
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ConfirmationType = {
  CONFIRMATION_TYPE_EXCH: 0,
  CONFIRMATION_TYPE_SELF: 1,
  CONFIRMATION_TYPE_AFTER_MARKET_ORDER: 2,
  CONFIRMATION_TYPE_MAX: 3
};

/**
 * @enum {number}
 */
proto.UT.PROTO.GrossExposureType = {
  GROSSEXPOSURETYPE_USER: 0,
  GROSSEXPOSURETYPE_SYMBOL: 1,
  GROSSEXPOSURETYPE_UNDERLYING: 2,
  GROSSEXPOSURETYPE_SCRIP: 3,
  GROSSEXPOSURETYPE_MAX: 4
};

/**
 * @enum {number}
 */
proto.UT.PROTO.OhlcInterval = {
  OHLCINTERVAL_ZERO: 0,
  OHLCINTERVAL_1_MIN: 1,
  OHLCINTERVAL_3_MIN: 3,
  OHLCINTERVAL_5_MIN: 5,
  OHLCINTERVAL_10_MIN: 10,
  OHLCINTERVAL_15_MIN: 15,
  OHLCINTERVAL_30_MIN: 30,
  OHLCINTERVAL_1_HOUR: 60,
  OHLCINTERVAL_4_HOUR: 240,
  OHLCINTERVAL_1_DAY: 1440,
  OHLCINTERVAL_5_DAYS: 7200,
  OHLCINTERVAL_1_MONTH: 43200
};

/**
 * @enum {number}
 */
proto.UT.PROTO.OhlcDataResponseCategory = {
  OHLCDATARESPONSECATEGORY_SUCCESS: 0,
  OHLCDATARESPONSECATEGORY_GENERAL_FAILURE: 1,
  OHLCDATARESPONSECATEGORY_LIMIT_EXCEEDED: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.SnapshotDataResponseCategory = {
  SNAPSHOTDATARESPONSECATEGORY_SUCCESS: 0,
  SNAPSHOTDATARESPONSECATEGORY_GENERAL_FAILURE: 1
};

/**
 * @enum {number}
 */
proto.UT.PROTO.EmailSMSType = {
  EMAILSMSTYPE_TRADE: 0,
  EMAILSMSTYPE_MARGIN_ALERT: 1,
  EMAILSMSTYPE_MTM_ALERT: 2,
  EMAILSMSTYPE_CLIENT_CREATION: 3,
  EMAILSMSTYPE_DEPOSIT_UPDATE: 4,
  EMAILSMSTYPE_PASSWORD_RESET: 5,
  EMAILSMSTYPE_WEB_MESSAGE: 6,
  EMAILSMSTYPE_MAX: 7,
  EMAILSMSTYPE_WHATSAPP_DISPOSITION: 8,
  EMAILSMSTYPE_USER_DAILY_PNL_REPORT: 9,
  EMAILSMSTYPE_USER_WEEKLY_PNL_REPORT: 10,
  EMAILSMSTYPE_USER_MONTHLY_PNL_REPORT: 11,
  EMAILSMSTYPE_USER_FREE_PLAN_EXPIRY_REMINDER: 12,
  EMAILSMSTYPE_USER_PAID_PLAN_EXPIRY_REMINDER: 13,
  EMAILSMSTYPE_USER_PAID_PLAN_WITH_AUTOPAY_RENEWAL_REMINDER: 14,
  EMAILSMSTYPE_USER_PLAN_EXPIRED: 15,
  EMAILSMSTYPE_USER_PLAN_RENEWAL_SUCCESS: 16,
  EMAILSMSTYPE_USER_PLAN_PURCHASE_SUCCESS: 17,
  EMAILSMSTYPE_USER_YEARLY_PNL_REPORT: 18,
  EMAILSMSTYPE_USER_QUARTERLY_PNL_REPORT: 19,
  EMAILSMSTYPE_USER_DAILY_PNL_MESSAGE: 20
};

/**
 * @enum {number}
 */
proto.UT.PROTO.LoginHistoryDataType = {
  LOGINHISTORYDATATYPE_CURRENT: 0,
  LOGINHISTORYDATATYPE_LAST_LOGINS: 1,
  LOGINHISTORYDATATYPE_LAST_DAYS: 2,
  LOGINHISTORYDATATYPE_MAX: 3
};

/**
 * @enum {number}
 */
proto.UT.PROTO.LoginHistoryResponseType = {
  LOGINHISTORYRESPONSETYPE_SUCCESS: 0,
  LOGINHISTORYRESPONSETYPE_FAILURE: 1,
  LOGINHISTORYRESPONSETYPE_MAX: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.FileTransferStatus = {
  FILETRANSFERSTATUS_NONE: 0,
  FILETRANSFERSTATUS_SUCCESS: 1,
  FILETRANSFERSTATUS_FAILURE: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ProductOrderCateGory = {
  PRODUCTORDERCATEGORY_NORMAL: 0,
  PRODUCTORDERCATEGORY_BRACKET: 1,
  PRODUCTORDERCATEGORY_COVER: 2,
  PRODUCTORDERCATEGORY_AMO: 3,
  PRODUCTORDERCATEGORY_MAX: 4
};

/**
 * @enum {number}
 */
proto.UT.PROTO.BocoOrderStatus = {
  BOCOORDERSTATUS_NEW: 0,
  BOCOORDERSTATUS_ACCEPTED: 1,
  BOCOORDERSTATUS_MODIFICATION_PENDING: 2,
  BOCOORDERSTATUS_MODIFICATION_REJECTED: 3,
  BOCOORDERSTATUS_CANCELLED: 4,
  BOCOORDERSTATUS_FILLED: 5,
  BOCOORDERSTATUS_PRODUCT_CONVERSION: 6,
  BOCOORDERSTATUS_MAX: 7
};

/**
 * @enum {number}
 */
proto.UT.PROTO.BOCOPriceType = {
  BOCOPRICETYPE_ABSOLUTE: 0,
  BOCOPRICETYPE_TICKS: 1,
  BOCOPRICETYPE_MAX: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.StopLossType = {
  STOPLOSSTYPE_NORMAL_ORDER: 0,
  STOPLOSSTYPE_TRAILING: 1,
  STOPLOSSTYPE_MAX: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.BocoStrategyUpdateType = {
  BOCOSTRATEGYUPDATETYPE_ONLINE: 0,
  BOCOSTRATEGYUPDATETYPE_AUTOSQUAREOFF: 1,
  BOCOSTRATEGYUPDATETYPE_ALERT_BREACH: 2,
  BOCOSTRATEGYUPDATETYPE_MAX: 3
};

/**
 * @enum {number}
 */
proto.UT.PROTO.StrategyActionType = {
  STRATEGYACTIONTYPE_REJECT_NEW: 0,
  STRATEGYACTIONTYPE_EXIT: 1,
  STRATEGYACTIONTYPE_RESUME: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.HoldingRequestType = {
  HOLDINGREQUESTTYPE_INVALID: 0,
  HOLDINGREQUESTTYPE_WHOLE: 1,
  HOLDINGREQUESTTYPE_DELTA: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.AuctionStatus = {
  AUCTIONSTATUS_NOT_INITIATED: 0,
  AUCTIONSTATUS_OPEN: 1,
  AUCTIONSTATUS_CLOSED: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.LoginType = {
  LOGINTYPE_OFFLINE: 0,
  LOGINTYPE_ONLINE: 1,
  LOGINTYPE_MAX: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ClientType = {
  CLIENTTYPE_PRO: 0,
  CLIENTTYPE_CILENT: 1,
  CLINTTYPE_MAX: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.RmsCheckCombinationType = {
  RMSCHECKCOMBINATIONTYPE_CLIENTCODE: 0,
  RMSCHECKCOMBINATIONTYPE_CLIENTCODEPLUSSYMBOL: 1,
  RMSCHECKCOMBINATIONTYPE_CLIENTCODEPLUSUNDERLYING: 2,
  RMSCHECKCOMBINATIONTYPE_CLIENTCODEPLUSPRODUCT: 3,
  RMSCHECKCOMBINATIONTYPE_CLIENTCODEPLUSPRODUCTPLUSSYMBOL: 4,
  RMSCHECKCOMBINATIONTYPE_CLIENTCODEPLUSPRODUCTPLUSSYMBOLBASKET: 5,
  RMSCHECKCOMBINATIONTYPE_CLIENTCODEPLUSSYMBOLBASKET: 6,
  RMSCHECKCOMBINATIONTYPE_DEALER: 7,
  RMSCHECKCOMBINATIONTYPE_DEALERPLUSSYMBOL: 8,
  RMSCHECKCOMBINATIONTYPE_DEALERPLUSUNDERLYING: 9,
  RMSCHECKCOMBINATIONTYPE_GROUP: 10,
  RMSCHECKCOMBINATIONTYPE_GROUPPLUSSYMBOL: 11,
  RMSCHECKCOMBINATIONTYPE_GROUPPLUSUNDERLYING: 12,
  RMSCHECKCOMBINATIONTYPE_BRANCH: 13,
  RMSCHECKCOMBINATIONTYPE_BRANCHPLUSSYMBOL: 14,
  RMSCHECKCOMBINATIONTYPE_PRODUCT: 15,
  RMSCHECKCOMBINATIONTYPE_PRODUCTPLUSSYMBOL: 16,
  RMSCHECKCOMBINATIONTYPE_PRODUCTPLUSSYMBOLBASKET: 17,
  RMSCHECKCOMBINATIONTYPE_SYMBOLBASKET: 18,
  RMSCHECKCOMBINATIONTYPE_SYMBOL: 19,
  RMSCHECKCOMBINATIONTYPE_UNDERLYING: 20,
  RMSCHECKCOMBINATIONTYPE_INFRACHECKS: 21,
  RMSCHECKCOMBINATIONTYPE_CLIENTPLUSSCRIPGROUP: 22,
  RMSCHECKCOMBINATIONTYPE_DEALERPLUSSCRIPGROUP: 23,
  RMSCHECKCOMBINATIONTYPE_INVALID: 24
};

/**
 * @enum {number}
 */
proto.UT.PROTO.RegisterationType = {
  REGISTERATIONTYPE_SUCCESSFULL: 0,
  REGISTERATIONTYPE_UNSUCCESSFULL: 1,
  REGISTERATIONTYPE_MAX: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.BracketCoverOrderState = {
  ORDERSTATE_PARENT: 0,
  ORDERSTATE_STOP_LOSS: 1,
  ORDERSTATE_TARGET: 2,
  ORDERSTATE_EXIT: 3,
  ORDERSTATE_SQUARE_OFF: 4
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ExposureSecurityType = {
  EXPOSURESECURITYTYPE_OTH: 0,
  EXPOSURESECURITYTYPE_DEEP_OTM: 1,
  EXPOSURESECURITYTYPE_MAX: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.JsonRequestType = {
  JSONREQUESTTYPE_ALERT: 0
};

/**
 * @enum {number}
 */
proto.UT.PROTO.JsonResponseType = {
  JSONRESPONSE_ALERT: 0,
  JSONRESPONSE_BACKTEST: 1
};

/**
 * @enum {number}
 */
proto.UT.PROTO.StrategyStatus = {
  STRATEGYSTATUS_TERMINATED: 0,
  STRATEGYSTATUS_RUNNING: 1,
  STRATEGYSTATUS_PAUSED: 2,
  STRATEGYSTATUS_AWAIT: 3,
  STRATEGYSTATUS_STOP_FOR_TODAY: 4,
  STRATEGYSTATUS_EXCH_DISCONNECTION_PAUSE: 5,
  STRATEGYSTATUS_SUSPENDED_TILL_TIMER_EXPIRE: 6,
  STRATEGYSTATUS_FORCE_TERMINATED: 7,
  STRATEGYSTATUS_MAX: 8
};

/**
 * @enum {number}
 */
proto.UT.PROTO.Responses_GENERIC_RESPONSE_ENUM = {
  RESPONSES_GENERIC_RESPONSE_LOGIN: 0
};

/**
 * @enum {number}
 */
proto.UT.PROTO.StrategyRequestStatus = {
  STATUS_IN_PROGRESS: 0,
  STATUS_COMPLETED: 1,
  STATUS_REQUEST_FAILURE: 2,
  STATUS_PENDING: 3,
  STATUS_TERMINATED: 4,
  STATUS_WEB_ACKNOWLEDGED: 5,
  STATUS_MAX: 6
};

/**
 * @enum {number}
 */
proto.UT.PROTO.MarginCalculatorErrorCode = {
  MARGINCALCULATORERRORCODE_SUCCESS: 0,
  MARGINCALCULATORERRORCODE_STATIC_DATA_NOT_FOUND: 1,
  MARGINCALCULATORERRORCODE_UNDERLYING_STATIC_DATA_NOT_FOUND: 2,
  MARGINCALCULATORERRORCODE_INVALID_SYMBOL: 3,
  MARGINCALCULATORERRORCODE_INVALID_ORDER_MODE: 4,
  MARGINCALCULATORERRORCODE_INVALID_LOTS: 5,
  MARGINCALCULATORERRORCODE_EXPOSURE_SETTING_NOT_FOUND: 6,
  MARGINCALCULATORERRORCODE_SPAN_NOT_FOUND: 7,
  MARGINCALCULATORERRORCODE_INVALID_TEMPLATE: 8,
  MARGINCALCULATORERRORCODE_MARGIN_PERCENTAGE_NOT_FOUND: 9,
  MARGINCALCULATORERRORCODE_INVALID_PRICE_FOR_LIMIT_ORDER: 10
};

/**
 * @enum {number}
 */
proto.UT.PROTO.BrokerConnectionStatus = {
  CONNECTIONSTATUS_INACTIVE: 0,
  CONNECTIONSTATUS_LOGGEDOUT: 1,
  CONNECTIONSTATUS_ACTIVE: 2,
  CONNECTIONSTATUS_KEYDELETED: 3
};

goog.object.extend(exports, proto.UT.PROTO);
